/**
 * Whether a host is a developer's own machine (#10718).
 *
 * The one answer to "is this a local development origin", for everything
 * that must stay off a developer's session: Sentry, the error log sink. The
 * client environment runs locally on a second loopback origin beside
 * `localhost` (`127.0.0.1` or `[::1]`, see `services/clientEnvironment.ts`),
 * so matching the word "localhost" alone reported those sessions as
 * production.
 *
 * Matched on the whole host name, never a substring: a deployed host whose
 * name contains "localhost" is not local.
 */
const LOOPBACK_HOSTS: ReadonlySet<string> = new Set([
  "localhost",
  "127.0.0.1",
  "[::1]",
]);

export function isLocalDevelopmentOrigin(
  hostname: string = window.location.hostname
): boolean {
  const host = hostname.toLowerCase();
  return LOOPBACK_HOSTS.has(host) || host.endsWith(".localhost");
}
